module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/CodeHighlight.worker.50e0.worker.js");
}
